import React, { useState, useEffect, useMemo } from "react";
import { fetchRoute } from "../../api";
import PlannerContainer from "../planner/PlannerContainer";
import { useItineraryTeasers } from "../explorer/hooks";
import Plausible from "plausible-tracker";

// //Plausible Tracking
// const { enableAutoPageviews, enableAutoOutboundTracking } = Plausible({
//     domain: "tripper.app",
// });
// enableAutoPageviews();
// enableAutoOutboundTracking();

const useRouteFetch = id => {
    const [data, setData] = useState(null);
    useEffect(() => {
        const callback = async () => {
            try {
                const { data } = await fetchRoute(id);
                setData(data);
            } catch (e) {
                return null;
            }
        };
        callback();
    }, [id]);
    return data;
};

export default function RouteContainer(props) {
    const { id: routeId, inLauncherModal, inLauncher } = props;
    const route = useRouteFetch(routeId);
    const [itineraryId, setItineraryId] = useState(null);
    const itineraryIds = useMemo(() => route?.itineraryData?.map(item => item.metadata.itineraryID) ?? [], [route]);
    const [itineraryTeasers] = useItineraryTeasers(itineraryIds);
    const routeItineraries = useMemo(() => {
        return (
            itineraryTeasers?.filter(itinerary => {
                return itinerary.id !== itineraryId;
            }) ?? []
        );
    }, [itineraryId, itineraryTeasers]);
    const enableChangeItinerary = routeItineraries && routeItineraries.length > 0 && (!inLauncher || inLauncherModal);

    useEffect(() => {
        const defaultItineraryId = route?.itineraryData?.[0]?.metadata?.itineraryID;
        setItineraryId(defaultItineraryId);
    }, [route]);

    if (!route) {
        return null;
    }

    return (
        <PlannerContainer
            itineraryId={itineraryId}
            routeItineraries={routeItineraries}
            enableChangeItinerary={enableChangeItinerary}
            onItineraryIdChange={setItineraryId}
            inLauncherModal={inLauncherModal}
        />
    );
}
